import styled from 'styled-components'

const TestimonialSectionStyle = styled.div`
	--testimonialIntWrap: 66.2%;
	--iconSize: var(--sp9x);
	--iconDistance: var(--sp3x);
	--marginNormalSize: var(--sp5x);
	--imageWidth: 10.1%;
	--imageHeight: 10.5%;

	margin-top: var(--secToTextSecToFooterDistance);
	margin-bottom: var(--secToTextSecToFooterDistance);
	display: flex;
	justify-content: center;

	.testimonialIntWrap {
		width: 100%;
		max-width: var(--testimonialIntWrap);
		text-align: center;

		.testimonialTextWrap {
			display: flex;
			justify-content: center;

			.addWrapper {
				width: fit-content;
				position: relative;

				i {
					position: absolute;

					&:before {
						font-size: var(--iconSize);
					}
				}

				.left {
					top: 0;
					left: 0;
					padding-right: var(--iconDistance);
					transform: translateX(-100%);
				}

				.right {
					bottom: 0;
					right: 0;
					padding-right: var(--iconDistance);
					transform: translateX(100%) rotateY(180deg);
				}
			}
		}

		.testimonialLogoWrap {
			display: flex;
			justify-content: center;
			margin-top: var(--marginNormalSize);

			.imageCont {
				--proportion: var(--imageHeight);
				width: var(--imageWidth);
			}
		}

		.author {
			margin-top: var(--marginNormalSize);
		}

		.position {
			margin-top: var(--sp1x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeL}) {
		--testimonialIntWrap: 66.4%;
		--iconSize: var(--sp8x);
		--iconDistance: var(--sp2x);
		--marginNormalSize: var(--sp3x);
		--imageWidth: 10.4%;
		--imageHeight: 10.9%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		--testimonialIntWrap: 66%;
		--iconSize: var(--sp7x);
		--iconDistance: var(--sp2x);
		--marginNormalSize: var(--sp3x);
		--imageWidth: 11.1%;
		--imageHeight: 11.5%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		--testimonialIntWrap: 66.3%;
		--iconSize: var(--sp7x);
		--iconDistance: var(--sp2x);
		--marginNormalSize: var(--sp3x);
		--imageWidth: 11.5%;
		--imageHeight: 11.9%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeXS}) {
		--testimonialIntWrap: 49%;
		--iconSize: var(--sp6x);
		--iconDistance: var(--sp2x);
		--marginNormalSize: var(--sp3x);
		--imageWidth: 14.4%;
		--imageHeight: 14.7%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
		--testimonialIntWrap: 48.8%;
		--iconSize: var(--sp5x);
		--iconDistance: var(--sp2x);
		--marginNormalSize: var(--sp2x);
		--imageWidth: 17.8%;
		--imageHeight: 18.2%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSizeS}) {
		--testimonialIntWrap: 74.2%;
		--iconSize: var(--sp4x);
		--iconDistance: var(--sp2x);
		--marginNormalSize: var(--sp2x);
		--imageWidth: 15.9%;
		--imageHeight: 16.3%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--testimonialIntWrap: 99.4%;
		--iconSize: var(--sp3x);
		--iconDistance: 0;
		--marginNormalSize: var(--sp2x);
		--imageWidth: 20.1%;
		--imageHeight: 20.6%;
	}
`

export default TestimonialSectionStyle
